import {env} from 'process'

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken, secrateKey},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      if (secrateKey) {
        config.headers['iTop-Subscription-Key'] = secrateKey
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
